module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tony Worobiec\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Tony Worobiec")]), _vm._v(" is author of several photography titles. He has won numerous awards and his work is held in collections throughout the world. He is regular contributor to photography magazines and has taught photoshop for the prestigious Royal Photographic Society.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FiiHl7/tc-custom/9781446359815.jpg?1740284537953",
      "alt": "This image is the cover for the book Creative Photography Ideas: Using Adobe Photoshop"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Creative Photography Ideas: Using Adobe Photoshop\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("Composites and further special effects")]), _vm._v(" is an excerpt from "), _c('i', [_vm._v("Creative Photography Ideas Using Photoshop")]), _vm._v(" which presents 75 comprehensive workshops that have been specifically designed for photographers; each offers a clever and creative technique that can be immediately applied.")]), _c('p', [_c('i', [_vm._v("Composites and further special effects")]), _vm._v(" workshops focus specifically on creating composites; from dropping in a sky to producing sunbeams, using multiple files, blending mode, refine edge, the gradient tool, multiple layers. There are plenty of creative ideas that will take your photography that little bit further from creating a 'joiner' or 'still movie' to joining two landscapes and creating a mirror image.")]), _c('p', [_vm._v("Each workshop offers ingenious creative techniques to immediately enhance images in Adobe Photoshop.")]), _c('p', [_vm._v("From basic techniques to more advanced, all guidance is ‘best practice’ and shown via clear explanatory texts, photographs, ‘before, during and after’ manipulations and screen grabs.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David & Charles Book\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0